import React from 'react';

import Field, { Props } from '../Field/Field';
import { Password as Input } from 'components/inputs';

const Password: React.FC<Props> = props => <Field {...props} component={Input} />;

Password.displayName = 'PasswordField';
export default Password;
